import React, { Component } from 'react';
import {
  WatchlistDateModel,
  WatchlistEducationModel,
  WatchlistIdentificationModel,
  WatchlistListsModel,
  WatchlistModel,
  WatchlistNameModel,
  WatchlistNameType,
  WatchlistPositionModel,
  WatchlistRelationshipModel,
  WatchlistSanctionModel,
} from '../../../domain/watchlist/WatchlistDomains';
import Icon from '../../../icons/Icon';
import WatchlistIdentificationsModalComponent from './modal/WatchlistIdentificationsModalComponent';
import WatchlistPositionsModalComponent from './modal/WatchlistPositionsModalComponent';
import WatchlistEducationsModalComponent from './modal/WatchlistEducationsModalComponent';
import WatchlistSanctionsModalComponent from './modal/WatchlistSanctionsModalComponent';
import WatchlistRelationshipsModalComponent from './modal/WatchlistRelationshipsModalComponent';
import { WatchlistType } from '../../../constant/Constants';
import WatchlistUtil from '../../../util/WatchlistUtil';
import WatchlistCustomListSourceLoader, { CustomListSourceDisplay } from '../../../util/WatchlistCustomListSourceLoader';
import NavigationUtil from '../../../util/NavigationUtil';
import _ from 'lodash';
import LanguageUtil from '../../../util/LanguageUtil';

class WatchlistResultComponent extends Component<Props, State> {
  public state = new State();

  public async componentDidMount(): Promise<void> {
    await this.loadCustomListSources();
  }

  public async componentDidUpdate(prevProps: Props): Promise<void> {
    if (this.buildLoadKey(prevProps) !== this.buildLoadKey(this.props)) {
      await this.loadCustomListSources();
    }
  }

  public render() {
    const { type } = this.props;
    const {
      identificationModalVisible,
      selectedIdentification,
      positionModalVisible,
      selectedPosition,
      educationModalVisible,
      selectedEducation,
      relationshipModalVisible,
      selectedRelationship,
      sanctionModalVisible,
      selectedSanction,
    } = this.state;

    return (
      <div className={'w-full'}>
        {this.getName()}
        {type === 'Individual' && this.getType('gender', LanguageUtil.get({ id: 'common.label.gender', defaultMessage: 'Gender' }))}
        {type === 'Entity' && this.getType('entityType', 'Type')}
        {type == 'Individual' && this.getIdentifications()}
        {type == 'Entity' && this.getIdentifier()}
        {type == 'Individual' && this.getCitizenships()}
        {type == 'Individual' && this.getDatesOfBirth()}
        {type == 'Individual' && this.getDatesOfDeath()}
        {type == 'Individual' && this.getPlaceOfBirth()}
        {type == 'Entity' && this.getDatesOfRegistration()}
        {this.getAddresses()}
        {type == 'Individual' && this.getPositions()}
        {type == 'Individual' && this.getEducations()}
        {this.getSanctions()}
        {type == 'Individual' && this.getRelationships()}
        <WatchlistIdentificationsModalComponent
          visible={identificationModalVisible}
          selectedData={selectedIdentification}
          onClose={() => this.setState({ identificationModalVisible: false })}
        />
        <WatchlistPositionsModalComponent
          visible={positionModalVisible}
          selectedData={selectedPosition}
          onClose={() => this.setState({ positionModalVisible: false })}
        />
        <WatchlistEducationsModalComponent
          visible={educationModalVisible}
          selectedData={selectedEducation}
          onClose={() => this.setState({ educationModalVisible: false })}
        />
        <WatchlistSanctionsModalComponent
          visible={sanctionModalVisible}
          selectedData={selectedSanction}
          onClose={() => this.setState({ sanctionModalVisible: false })}
        />
        <WatchlistRelationshipsModalComponent
          visible={relationshipModalVisible}
          selectedData={selectedRelationship}
          onClose={() => this.setState({ relationshipModalVisible: false })}
        />
      </div>
    );
  }

  private getName = () => {
    const { showName } = this.state;
    const namesData = this.dataNormalize('names');
    if (namesData == undefined || namesData.length == 0) {
      return this.generateNotFound('Names', 'kyc_namesicon');
    }
    const data: any[] = this.getNameGroups();
    return (
      <div className='flex border-b border-b-[0.5px]'>
        {this.generateHeader(LanguageUtil.get({ id: 'common.label.names', defaultMessage: 'Names' }), 'kyc_namesicon')}
        <div className='flex flex-col w-4/5 justify-center'>
          {data
            .map((data, index) => {
              return (
                <div
                  className={`flex transition duration-500 h-auto ${namesData?.length < 5 && namesData.length - 1 == index ? '' : 'border-b border-b-[0.5px]'}`}
                  key={index}
                >
                  <div className={'flex w-1/2 items-center py-4 gap-x-2'}>
                    <span className={'text-f-black-2 text-md'}>{data.data.value}</span>
                    {this.getNameStatus(data.data.nameType)}
                  </div>
                  {this.generateListStatus(data.watchlistId, data.source)}
                </div>
              );
            })
            .slice(0, showName ? undefined : 4)}
          {namesData?.length > 4 && (
            <div className={'flex justify-center items-center p-3'}>
              <span onClick={() => this.setState({ showName: !showName })} className='text-[#458EF7] text-md cursor-pointer'>
                {showName ? this.hidePanel() : this.showPanel(namesData.length, 'names')}
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };

  private getType = (property: string, displayProperty: string) => {
    const { selectedResponse } = this.props;
    const typeData = selectedResponse?.find((data) => (data.watchlistRecord as any)[property] !== undefined);
    if (typeData === undefined) {
      return this.generateNotFound(displayProperty, 'kyc_gender');
    }
    const detail = (typeData.watchlistRecord as any)[property];
    return (
      <div className='flex border-b border-b-[0.5px]'>
        {this.generateHeader(displayProperty, 'kyc_gender')}
        <div className='flex flex-col w-4/5 justify-center'>
          <div className='flex transition duration-500 h-auto items-center'>
            <div className='flex w-1/2 items-center gap-x-2'>
              <span className='text-f-black-2 text-md'>
                {detail
                  ? detail.charAt(0).toUpperCase() + detail.slice(1).toLowerCase()
                  : LanguageUtil.get({
                      id: 'common.label.notAvailable',
                      defaultMessage: 'Not Available',
                    })}
              </span>
            </div>
            {this.generateListStatus(typeData.watchlistId, typeData.watchlistRecord.source)}
          </div>
        </div>
      </div>
    );
  };

  private getIdentifications = () => {
    const { showIdentification } = this.state;
    const identificationsData = this.dataNormalize('identifications');
    if (identificationsData == undefined || identificationsData.length == 0) {
      return this.generateNotFound(
        LanguageUtil.get({
          id: 'common.label.identifications',
          defaultMessage: 'Identifications',
        }),
        'kyc_identificationsicon',
      );
    }
    return (
      <div className='flex border-b border-b-[0.5px]'>
        {this.generateHeader(LanguageUtil.get({ id: 'common.label.identifications', defaultMessage: 'Identifications' }), 'kyc_identificationsicon')}
        <div className='flex flex-col w-4/5 justify-center'>
          {identificationsData
            .map((data: any, index) => {
              const value: any = data.data.value || LanguageUtil.get({ id: 'common.label.notAvailable', defaultMessage: 'Not Available' });
              return (
                <div
                  key={index}
                  className={`flex transition duration-500 h-auto ${identificationsData?.length < 5 && identificationsData.length - 1 == index ? '' : 'border-b border-b-[0.5px]'}`}
                >
                  <div className={'flex w-1/2 items-center gap-x-2'}>
                    <div className={'flex gap-x-1 items-center'}>
                      <span className={'text-[#8C2822] text-md'}>{value.length > 40 ? value.substring(0, 40) + '...' : value}</span>
                      <Icon
                        icon={'error'}
                        size={16}
                        className={'text-[#8C2822] cursor-pointer'}
                        onClick={() => {
                          this.setState({
                            identificationModalVisible: true,
                            selectedIdentification: { ...data.data, source: data.source },
                          });
                        }}
                      />
                    </div>
                    <span className={'text-md items-center text-[#5925DC] bg-[#F4F3FF] rounded-xl px-[8px] py-[3px]'}>
                      {data.data.type ||
                        LanguageUtil.get({
                          id: 'common.label.unknown',
                          defaultMessage: 'Unknown',
                        })}
                    </span>
                  </div>
                  {this.generateListStatus(data.watchlistId, data.source)}
                </div>
              );
            })
            .slice(0, showIdentification ? undefined : 4)}
          {identificationsData.length > 4 && (
            <div className={'flex justify-center items-center p-3'}>
              <span onClick={() => this.setState({ showIdentification: !showIdentification })} className='text-[#458EF7] text-md cursor-pointer'>
                {showIdentification ? this.hidePanel() : this.showPanel(identificationsData.length, 'identifications')}
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };

  private getIdentifier = () => {
    const { showIdentification } = this.state;
    const identifiersData = this.dataNormalize('identifiers');
    if (identifiersData == undefined || identifiersData.length == 0) {
      return this.generateNotFound(LanguageUtil.get({ id: 'common.label.identifier', defaultMessage: 'Identifier' }), 'kyc_identificationsicon');
    }
    return (
      <div className='flex border-b border-b-[0.5px]'>
        {this.generateHeader(LanguageUtil.get({ id: 'common.label.identifier', defaultMessage: 'Identifier' }), 'kyc_identificationsicon')}
        <div className='flex flex-col w-4/5 justify-center'>
          {identifiersData
            .map((data: any, index) => {
              return (
                <div
                  key={index}
                  className={`flex transition duration-500 h-auto ${identifiersData?.length < 5 && identifiersData.length - 1 == index ? '' : 'border-b border-b-[0.5px]'}`}
                >
                  <div className={'flex w-1/2 items-center gap-x-2'}>
                    <div className={'flex gap-x-1 items-center'}>
                      <span className={'text-[#8C2822] text-md'}>
                        {data.data.value ||
                          LanguageUtil.get({
                            id: 'common.label.notAvailable',
                            defaultMessage: 'Not Available',
                          })}
                      </span>
                      <Icon
                        icon={'error'}
                        size={16}
                        className={'text-f-black-3 cursor-pointer'}
                        onClick={() => {
                          this.setState({
                            identificationModalVisible: true,
                            selectedIdentification: { ...data.data, source: data.source },
                          });
                        }}
                      />
                    </div>
                    <span className={'text-md text-[#5925DC] bg-[#F4F3FF] rounded-xl px-[8px] py-[3px]'}>
                      {data.data.type ||
                        LanguageUtil.get({
                          id: 'common.label.unknown',
                          defaultMessage: 'Unknown',
                        })}
                    </span>
                  </div>
                  {this.generateListStatus(data.watchlistId, data.source)}
                </div>
              );
            })
            .slice(0, showIdentification ? undefined : 4)}
          {identifiersData.length > 4 && (
            <div className={'flex justify-center items-center p-3'}>
              <span onClick={() => this.setState({ showIdentification: !showIdentification })} className='text-[#458EF7] text-md cursor-pointer'>
                {showIdentification ? this.hidePanel() : this.showPanel(identifiersData.length, 'identifiers')}
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };

  private getCitizenships = () => {
    const { showCitizenship } = this.state;
    const citizenshipData = this.dataNormalize('citizenships');
    if (citizenshipData == undefined || citizenshipData.length == 0) {
      return this.generateNotFound(LanguageUtil.get({ id: 'common.label.citizenships', defaultMessage: 'Citizenships' }), 'kyc_citizenshipsicon');
    }
    return (
      <div className='flex border-b border-b-[0.5px]'>
        {this.generateHeader(LanguageUtil.get({ id: 'common.label.citizenships', defaultMessage: 'Citizenships' }), 'kyc_citizenshipsicon')}
        <div className='flex flex-col w-4/5 justify-center'>
          {citizenshipData
            .map((data: any, index) => {
              return (
                <div
                  key={index}
                  className={`flex transition duration-500 h-auto ${citizenshipData?.length < 5 && citizenshipData.length - 1 == index ? '' : 'border-b border-b-[0.5px]'}`}
                >
                  <div className={'flex w-1/2 items-center gap-x-2'}>
                    <div className={'flex gap-x-3 items-center'}>
                      <span className={'text-f-black-2 text-md'}>
                        {data.data ||
                          LanguageUtil.get({
                            id: 'common.label.notAvailable',
                            defaultMessage: 'Not Available',
                          })}
                      </span>
                      <img src={`/country/${data.data}.svg`} className={'w-[20px] h-[20px]'} alt='country' />
                    </div>
                  </div>
                  {this.generateListStatus(data.watchlistId, data.source)}
                </div>
              );
            })
            .slice(0, showCitizenship ? undefined : 4)}
          {citizenshipData.length > 4 && (
            <div className={'flex justify-center items-center p-3'}>
              <span onClick={() => this.setState({ showCitizenship: !showCitizenship })} className='text-[#458EF7] text-md cursor-pointer'>
                {showCitizenship ? this.hidePanel() : this.showPanel(citizenshipData.length, 'citizenships')}
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };

  private getDatesOfRegistration = () => {
    const { showDateOfRegistration } = this.state;
    const datesOfRegistrationData = this.dataNormalize('datesOfRegistration');
    if (datesOfRegistrationData == undefined || datesOfRegistrationData.length == 0) {
      return this.generateNotFound('Dates Of Registration', 'kyc_datesofbirthicon');
    }
    return (
      <div className='flex border-b border-b-[0.5px]'>
        {this.generateHeader(
          LanguageUtil.get({
            id: 'common.label.datesOfRegistrations',
            defaultMessage: 'Dates of Registrations',
          }),
          'kyc_datesofbirthicon',
        )}
        <div className='flex flex-col w-4/5 justify-center'>
          {datesOfRegistrationData
            .map((data: any, index) => {
              return (
                <div
                  key={index}
                  className={`flex transition duration-500 h-auto ${datesOfRegistrationData?.length < 5 && datesOfRegistrationData.length - 1 == index ? '' : 'border-b border-b-[0.5px]'}`}
                >
                  <div className={'flex w-1/2 items-center gap-x-2'}>
                    <div className={'flex gap-x-1 items-center'}>
                      <span className={'text-f-black-2 text-md'}>{this.getDate(data.data)}</span>
                    </div>
                  </div>
                  {this.generateListStatus(data.watchlistId, data.source)}
                </div>
              );
            })
            .slice(0, showDateOfRegistration ? undefined : 4)}
          {datesOfRegistrationData.length > 4 && (
            <div className={'flex justify-center items-center p-3'}>
              <span onClick={() => this.setState({ showDateOfRegistration: !showDateOfRegistration })} className='text-[#458EF7] text-md cursor-pointer'>
                {showDateOfRegistration ? this.hidePanel() : this.showPanel(datesOfRegistrationData.length, 'registrations')}
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };

  private getDatesOfBirth = () => {
    const { showDateOfBirth } = this.state;
    const dateOfBirthData = this.dataNormalize('datesOfBirth');
    if (dateOfBirthData == undefined || dateOfBirthData.length == 0) {
      return this.generateNotFound(LanguageUtil.get({ id: 'common.label.datesOfBirth', defaultMessage: 'Dates of Birth' }), 'kyc_datesofbirthicon');
    }
    return (
      <div className='flex border-b border-b-[0.5px]'>
        {this.generateHeader(LanguageUtil.get({ id: 'common.label.datesOfBirth', defaultMessage: 'Dates of Birth' }), 'kyc_datesofbirthicon')}
        <div className='flex flex-col w-4/5 justify-center'>
          {dateOfBirthData
            .map((data: any, index) => {
              return (
                <div
                  key={index}
                  className={`flex transition duration-500 h-auto ${dateOfBirthData?.length < 5 && dateOfBirthData.length - 1 == index ? '' : 'border-b border-b-[0.5px]'}`}
                >
                  <div className={'flex w-1/2 items-center gap-x-2'}>
                    <div className={'flex gap-x-1 items-center'}>
                      <span className={'text-f-black-2 text-md'}>{this.getDate(data.data)}</span>
                    </div>
                  </div>
                  {this.generateListStatus(data.watchlistId, data.source)}
                </div>
              );
            })
            .slice(0, showDateOfBirth ? undefined : 4)}
          {dateOfBirthData.length > 4 && (
            <div className={'flex justify-center items-center p-3'}>
              <span onClick={() => this.setState({ showDateOfBirth: !showDateOfBirth })} className='text-[#458EF7] text-md cursor-pointer'>
                {showDateOfBirth ? this.hidePanel() : this.showPanel(dateOfBirthData.length, 'birth dates')}
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };

  private getDatesOfDeath = () => {
    const { showDateOfDeath } = this.state;
    const dateOfDeathData = this.dataNormalize('datesOfDeath');
    if (dateOfDeathData == undefined || dateOfDeathData.length == 0) {
      return this.generateNotFound(LanguageUtil.get({ id: 'common.label.datesOfDeath', defaultMessage: 'Dates of Death' }), 'kyc_datesofbirthicon');
    }
    return (
      <div className='flex border-b border-b-[0.5px]'>
        {this.generateHeader(LanguageUtil.get({ id: 'common.label.datesOfDeath', defaultMessage: 'Dates of Death' }), 'kyc_datesofbirthicon')}
        <div className='flex flex-col w-4/5 justify-center'>
          {dateOfDeathData
            .map((data: any, index) => {
              return (
                <div
                  key={index}
                  className={`flex transition duration-500 h-auto ${dateOfDeathData?.length < 5 && dateOfDeathData.length - 1 == index ? '' : 'border-b border-b-[0.5px]'}`}
                >
                  <div className={'flex w-1/2 items-center gap-x-2'}>
                    <div className={'flex gap-x-1 items-center'}>
                      <span className={'text-f-black-2 text-md'}>{this.getDate(data.data)}</span>
                    </div>
                  </div>
                  {this.generateListStatus(data.watchlistId, data.source)}
                </div>
              );
            })
            .slice(0, showDateOfDeath ? undefined : 4)}
          {dateOfDeathData.length > 4 && (
            <div className={'flex justify-center items-center p-3'}>
              <span onClick={() => this.setState({ showDateOfDeath: !showDateOfDeath })} className='text-[#458EF7] text-md cursor-pointer'>
                {showDateOfDeath ? this.hidePanel() : this.showPanel(dateOfDeathData.length, 'death dates')}
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };

  private getPlaceOfBirth = () => {
    const { showPlaceOfBirth } = this.state;
    const placeOfBirthData = this.dataNormalize('placesOfBirth');
    if (placeOfBirthData == undefined || placeOfBirthData.length == 0) {
      return this.generateNotFound(LanguageUtil.get({ id: 'common.label.placesOfBirth', defaultMessage: 'Places of Birth' }), 'kyc_placesofbirthicon');
    }
    return (
      <div className='flex border-b border-b-[0.5px]'>
        {this.generateHeader(LanguageUtil.get({ id: 'common.label.placesOfBirth', defaultMessage: 'Places of Birth' }), 'kyc_placesofbirthicon')}
        <div className='flex flex-col w-4/5 justify-center'>
          {placeOfBirthData
            .map((data: any, index) => {
              return (
                <div
                  key={index}
                  className={`flex transition duration-500 h-auto ${placeOfBirthData?.length < 5 && placeOfBirthData.length - 1 == index ? '' : 'border-b border-b-[0.5px]'}`}
                >
                  <div className={'flex w-1/2 items-center gap-x-2'}>
                    <div className={'flex gap-x-1 items-center'}>
                      <span className={'text-f-black-2 text-md'}>
                        {data.data ||
                          LanguageUtil.get({
                            id: 'common.label.notAvailable',
                            defaultMessage: 'Not Available',
                          })}
                      </span>
                    </div>
                  </div>
                  {this.generateListStatus(data.watchlistId, data.source)}
                </div>
              );
            })
            .slice(0, showPlaceOfBirth ? undefined : 4)}
          {placeOfBirthData.length > 4 && (
            <div className={'flex justify-center items-center p-3'}>
              <span onClick={() => this.setState({ showPlaceOfBirth: !showPlaceOfBirth })} className='text-[#458EF7] text-md cursor-pointer'>
                {showPlaceOfBirth ? this.hidePanel() : this.showPanel(placeOfBirthData.length, 'birth places')}
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };

  private getAddresses = () => {
    const { showAddresses } = this.state;
    const addressesData = this.dataNormalize('addresses');
    if (addressesData == undefined || addressesData.length == 0) {
      return this.generateNotFound(LanguageUtil.get({ id: 'common.label.addresses', defaultMessage: 'Addresses' }), 'kyc_addressesicon');
    }
    return (
      <div className='flex border-b border-b-[0.5px]'>
        {this.generateHeader(LanguageUtil.get({ id: 'common.label.addresses', defaultMessage: 'Addresses' }), 'kyc_addressesicon')}
        <div className='flex flex-col w-4/5 justify-center'>
          {addressesData
            .map((data: any, index) => {
              return (
                <div
                  key={index}
                  className={`flex transition duration-500 h-auto ${addressesData?.length < 5 && addressesData.length - 1 == index ? '' : 'border-b border-b-[0.5px]'}`}
                >
                  <div className={'flex w-1/2 items-center gap-x-2'}>
                    <div className={'flex gap-x-1 items-center'}>
                      <span className={'text-f-black-2 text-md'}>
                        {data.data ||
                          LanguageUtil.get({
                            id: 'common.label.notAvailable',
                            defaultMessage: 'Not Available',
                          })}
                      </span>
                    </div>
                  </div>
                  {this.generateListStatus(data.watchlistId, data.source)}
                </div>
              );
            })
            .slice(0, showAddresses ? undefined : 4)}
          {addressesData.length > 4 && (
            <div className={'flex justify-center items-center p-3'}>
              <span onClick={() => this.setState({ showAddresses: !showAddresses })} className='text-[#458EF7] text-md cursor-pointer'>
                {showAddresses ? this.hidePanel() : this.showPanel(addressesData.length, 'addresses')}
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };

  private getPositions = () => {
    const { showPosition } = this.state;
    const positionsData = this.dataNormalize('positions');
    if (positionsData == undefined || positionsData.length == 0) return;
    return (
      <div className='flex border-b border-b-[0.5px]'>
        {this.generateHeader(LanguageUtil.get({ id: 'common.label.positions', defaultMessage: 'Positions' }), 'kyc_positionsicon')}
        <div className='flex flex-col w-4/5 justify-center'>
          {positionsData
            .map((data: any, index) => {
              return (
                <div
                  key={index}
                  className={`flex transition duration-500 h-auto ${positionsData?.length < 5 && positionsData.length - 1 == index ? '' : 'border-b border-b-[0.5px]'}`}
                >
                  <div className={'flex w-1/2 items-center gap-x-2'}>
                    <div className={'flex gap-x-1 items-center'}>
                      <span className={'text-f-black-2 text-md'}>
                        {data.data.name ||
                          LanguageUtil.get({
                            id: 'common.label.notAvailable',
                            defaultMessage: 'Not Available',
                          })}
                      </span>
                      <Icon
                        icon={'error'}
                        size={16}
                        className={'text-f-black-3 cursor-pointer'}
                        onClick={() => {
                          this.setState({
                            positionModalVisible: true,
                            selectedPosition: { ...data.data, source: data.source },
                          });
                        }}
                      />
                    </div>
                  </div>
                  {this.generateListStatus(data.watchlistId, data.source)}
                </div>
              );
            })
            .slice(0, showPosition ? undefined : 4)}
          {positionsData.length > 4 && (
            <div className={'flex justify-center items-center p-3'}>
              <span onClick={() => this.setState({ showPosition: !showPosition })} className='text-[#458EF7] text-md cursor-pointer'>
                {showPosition ? this.hidePanel() : this.showPanel(positionsData.length, 'positions')}
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };

  private getEducations = () => {
    const { showEducation } = this.state;
    const educationData = this.dataNormalize('educations');
    if (educationData == undefined || educationData.length == 0) return;
    return (
      <div className='flex border-b border-b-[0.5px]'>
        {this.generateHeader(LanguageUtil.get({ id: 'common.label.educations', defaultMessage: 'Educations' }), 'kyc_educationsicon')}
        <div className='flex flex-col w-4/5 justify-center'>
          {educationData
            .map((data: any, index) => {
              return (
                <div
                  key={index}
                  className={`flex transition duration-500 h-auto ${educationData?.length < 5 && educationData.length - 1 == index ? '' : 'border-b border-b-[0.5px]'}`}
                >
                  <div className={'flex w-1/2 items-center gap-x-2'}>
                    <div className={'flex gap-x-1 items-center'}>
                      <span className={'text-f-black-2 text-md'}>
                        {data.data.name ||
                          LanguageUtil.get({
                            id: 'common.label.notAvailable',
                            defaultMessage: 'Not Available',
                          })}
                      </span>
                      <Icon
                        icon={'error'}
                        size={16}
                        className={'text-f-black-3 cursor-pointer'}
                        onClick={() => {
                          this.setState({
                            educationModalVisible: true,
                            selectedEducation: { ...data.data, source: data.source },
                          });
                        }}
                      />
                    </div>
                  </div>
                  {this.generateListStatus(data.watchlistId, data.source)}
                </div>
              );
            })
            .slice(0, showEducation ? undefined : 4)}
          {educationData.length > 4 && (
            <div className={'flex justify-center items-center p-3'}>
              <span onClick={() => this.setState({ showEducation: !showEducation })} className='text-[#458EF7] text-md cursor-pointer'>
                {showEducation ? this.hidePanel() : this.showPanel(educationData.length, 'educations')}
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };

  private getSanctions = () => {
    const { showSanction } = this.state;
    const sanctionsData = this.dataNormalize('sanctions');
    if (sanctionsData == undefined || sanctionsData.length == 0) return;
    return (
      <div className='flex border-b border-b-[0.5px]'>
        {this.generateHeader(LanguageUtil.get({ id: 'common.label.sanctions', defaultMessage: 'Sanctions' }), 'kyc_sanctionsicon')}
        <div className='flex flex-col w-4/5 justify-center'>
          {sanctionsData
            .map((data: any, index) => {
              const value: any = data.data.program || LanguageUtil.get({ id: 'common.label.notAvailable', defaultMessage: 'Not Available' });
              return (
                <div
                  key={index}
                  className={`flex transition duration-500 h-auto ${sanctionsData?.length < 5 && sanctionsData.length - 1 == index ? '' : 'border-b border-b-[0.5px]'}`}
                >
                  <div className={'flex w-1/2 items-center gap-x-2'}>
                    <div className={'flex w-full gap-x-1 items-center'}>
                      <span className={'text-f-black-2 text-md'}>{value.length > 40 ? value.substring(0, 40) + '...' : value}</span>
                      <Icon
                        icon={'error'}
                        className={'text-f-black-3 cursor-pointer !min-w-[16px] !min-h-[16px] !max-w-[16px] !max-h-[16px]'}
                        onClick={() => {
                          this.setState({
                            sanctionModalVisible: true,
                            selectedSanction: { ...data.data, source: data.source },
                          });
                        }}
                      />
                    </div>
                  </div>
                  {this.generateListStatus(data.watchlistId, data.source)}
                </div>
              );
            })
            .slice(0, showSanction ? undefined : 4)}
          {sanctionsData.length > 4 && (
            <div className={'flex justify-center items-center p-3'}>
              <span onClick={() => this.setState({ showSanction: !showSanction })} className='text-[#458EF7] text-md cursor-pointer'>
                {showSanction ? this.hidePanel() : this.showPanel(sanctionsData.length, 'sanctions')}
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };

  private getRelationships = () => {
    const { showRelationship } = this.state;
    const relationshipsData = this.dataNormalize('relationships');
    if (relationshipsData == undefined || relationshipsData.length == 0) return;
    return (
      <div className='flex border-b border-b-[0.5px]'>
        {this.generateHeader(LanguageUtil.get({ id: 'common.label.relationship', defaultMessage: 'Relationship' }), 'kyc_relationshipsicon')}
        <div className='flex flex-col w-4/5 justify-center'>
          {relationshipsData
            .map((data: any, index) => {
              const type: string | undefined = data.data?.type
                ? (data.data.type as string)
                    .split('_')
                    .map((item: string) => item.charAt(0).toUpperCase() + item.slice(1).toLowerCase())
                    .join(' ')
                : undefined;
              return (
                <div
                  key={index}
                  className={`flex transition duration-500 h-auto ${relationshipsData?.length < 5 && relationshipsData.length - 1 == index ? '' : 'border-b border-b-[0.5px]'}`}
                >
                  <div className={'flex w-1/2 items-center gap-x-2'}>
                    <div className={'flex gap-x-1 items-center'}>
                      <span className={'text-f-black-2 text-md'}>
                        {data.data.value ||
                          LanguageUtil.get({
                            id: 'common.label.notAvailable',
                            defaultMessage: 'Not Available',
                          })}
                      </span>
                      <Icon
                        icon={'error'}
                        size={16}
                        className={'text-f-black-3 cursor-pointer'}
                        onClick={() => {
                          this.setState({
                            relationshipModalVisible: true,
                            selectedRelationship: { ...data.data, source: data.source },
                          });
                        }}
                      />
                      {data.data?.id && (
                        <Icon
                          icon={'kyc_relationdetailsicon'}
                          className={'cursor-pointer text-f-black-3'}
                          size={18}
                          onClick={() => this.redirectRelation({ ...data.data, watchlistId: data.watchlistId })}
                        />
                      )}
                    </div>
                    {type && (
                      <span className={'flex justify-center min-w-[88px] text-md text-[#5925DC] bg-[#F4F3FF] rounded-xl px-[8px] py-[3px]'}>{type}</span>
                    )}
                  </div>
                  {this.generateListStatus(data.watchlistId, data.source)}
                </div>
              );
            })
            .slice(0, showRelationship ? undefined : 4)}
          {relationshipsData.length > 4 && (
            <div className={'flex justify-center items-center p-3'}>
              <span onClick={() => this.setState({ showRelationship: !showRelationship })} className='text-[#458EF7] text-md cursor-pointer'>
                {showRelationship ? this.hidePanel() : this.showPanel(relationshipsData.length, 'relationships')}
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };

  private redirectRelation = (selectedData: WatchlistRelationshipModel) => {
    const urlParams = new URLSearchParams();
    urlParams.set('listId', selectedData?.watchlistId || '');
    urlParams.set('relationId', selectedData?.id || '');
    urlParams.set('name', selectedData?.value || '');
    window.open(`/${NavigationUtil.getTenant()}/watchlist/relation-detail/${urlParams.toString()}`, '_blank', 'noopener noreferrer');
  };

  private getDate = (data: WatchlistDateModel) => {
    return `${data.day || ''} ${WatchlistUtil.getMonth(data.month)} ${data.year || ''}`;
  };

  private getListName = (listId: string) => {
    const customListSource: CustomListSourceDisplay | undefined = this.state.customListSources[listId];
    if (customListSource != undefined) {
      return customListSource.name;
    }
    return this.getList(listId)?.name;
  };

  private dataNormalize = (field: string) => {
    const { selectedResponse } = this.props;
    const flattenedArray: any[] = selectedResponse?.map((value) => {
      return (value.watchlistRecord as any)[field]?.map((data: any) => {
        return {
          data: data,
          watchlistId: value.watchlistId,
          source: value.watchlistRecord.source,
        };
      });
    });
    return [].concat(...flattenedArray);
  };

  private getNameGroups = () => {
    const namesData = this.dataNormalize('names');
    const data: any[] = [];
    const groupedData: { [key: string]: WatchlistNameModel[] } = {};
    namesData.forEach((data: any) => {
      const type = data.data.nameType;
      if (!groupedData[type]) {
        groupedData[type] = [];
      }
      groupedData[type].push(data);
    });
    for (const type in groupedData) {
      if (groupedData.hasOwnProperty(type)) {
        groupedData[type].sort((a: any, b: any) => {
          return b.data.value.length - a.data.value.length;
        });
      }
    }
    ['PRIMARY', 'ALIAS', 'SCRIPT'].forEach((type) => {
      if (groupedData[type]) {
        data.push(...groupedData[type]);
      }
    });
    return data;
  };

  private getNameStatus = (type: WatchlistNameType) => {
    if (type == WatchlistNameType.PRIMARY) {
      return (
        <span className={'text-md text-[#027A48] bg-[#E7FFF1] rounded-xl px-[8px] py-[3px]'}>{type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()}</span>
      );
    } else if (type == WatchlistNameType.ALIAS) {
      return (
        <span className={'text-md text-[#175CD3] bg-[#EFF8FF] rounded-xl px-[8px] py-[3px]'}>{type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()}</span>
      );
    } else if (type == WatchlistNameType.SCRIPT) {
      return (
        <span className={'text-md text-[#5925DC] bg-[#F4F3FF] rounded-xl px-[8px] py-[3px]'}>{type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()}</span>
      );
    }
  };

  private generateNotFound = (name: string, icon: string) => {
    return (
      <div className='flex border-b border-b-[0.5px] p-0.5'>
        <div className='flex flex-col w-1/5'>
          <div className={'py-2 flex items-center gap-x-1'}>
            <span key={'icon'} className='w-[40px] h-[40px] flex justify-center items-center rounded-[50%] bg-[#EFF2FE] mr-1'>
              <Icon icon={icon} className={'w-[20px] h-[20px]'} color={'#728EFF'} />
            </span>
            <span className={'text-f-black-2 font-medium text-md'}>{name}</span>
          </div>
        </div>
        <div className='flex flex-col w-4/5 justify-center'>
          <div className={`flex transition duration-500 h-auto`}>
            <div className={'flex w-1/2 items-center gap-x-2'}>
              <div className={'flex gap-x-1 items-center'}>
                <span className={'text-f-black-2 text-md'}>{LanguageUtil.get({ id: 'common.label.dataNotFound', defaultMessage: 'Data Not Found' })}</span>
              </div>
            </div>
            <div className={'flex w-1/2 py-4 justify-end gap-x-2 items-center'}>
              <Icon icon={'datanotfound'} color={'#D0D0D0'} size={16} />
            </div>
          </div>
        </div>
      </div>
    );
  };

  private generateListStatus = (listId: string, source: string) => {
    return (
      <div className={'flex w-1/2 py-4 justify-end gap-x-2 items-center'}>
        <span className={'text-md text-[#4F4F4F] bg-[#F2F4F7] rounded-xl px-[8px] py-[3px]'}>{this.getListName(listId)}</span>
        {!this.isCustomList(listId) && (
          <Icon icon={'link'} size={16} color={'#458EF7'} className={'cursor-pointer'} onClick={() => window.open(source, '_blank')} />
        )}
      </div>
    );
  };

  private isCustomList = (listId: string): boolean => {
    if (this.state.customListSources[listId] != undefined) {
      return true;
    }
    return WatchlistUtil.isCustomList(this.getList(listId));
  };

  private getList = (listId: string): WatchlistListsModel | undefined => {
    const { watchlistResponse } = this.props;
    if (watchlistResponse && watchlistResponse.length > 0) {
      return watchlistResponse.find((list) => list.id == listId);
    }
    return undefined;
  };

  private buildLoadKey = (props: Props): string => {
    const watchlistIds: string = (props.selectedResponse || []).map((item: WatchlistModel) => item.watchlistId).join('|');
    const listIds: string = (props.watchlistResponse || []).map((list: WatchlistListsModel) => list.id).join('|');
    const preferred: string = props.preferredCustomListSource ? `${props.preferredCustomListSource.name}:${props.preferredCustomListSource.size}` : '';
    return `${watchlistIds}::${listIds}::${preferred}`;
  };

  private loadCustomListSources = async (): Promise<void> => {
    const customListSources: Record<string, CustomListSourceDisplay> = await WatchlistCustomListSourceLoader.load(
      (this.props.selectedResponse || []).map((item: WatchlistModel) => item.watchlistId),
      this.props.watchlistResponse || [],
      this.props.preferredCustomListSource,
    );
    this.setState({ customListSources });
  };

  private generateHeader = (title: string, icon: string) => {
    return (
      <div className='flex flex-col w-1/5'>
        <div className={'py-2 flex items-center gap-x-1'}>
          <span key={'icon'} className='w-[40px] h-[40px] flex justify-center items-center rounded-[50%] bg-[#EFF2FE] mr-1'>
            <Icon icon={icon} className={'w-[20px] h-[20px]'} color={'#728EFF'} />
          </span>
          <span className={'text-f-black-2 font-medium text-md'}>{title}</span>
        </div>
      </div>
    );
  };

  private showPanel = (size: number, name: string) => {
    return (
      <div>
        <Icon icon={'arrow-down'} size={20} />
        {LanguageUtil.get(
          { id: 'common.button.arrowDown', defaultMessage: `Click here to view ${size - 4} more ${name} ...` },
          {
            0: `${size - 4}`,
            1: `${name}`,
          },
        )}
      </div>
    );
  };

  private hidePanel = () => {
    return (
      <div>
        <Icon icon={'arrow-up'} size={20} />
        {LanguageUtil.get({ id: 'common.label.showLess', defaultMessage: 'Show less' })}
      </div>
    );
  };
}

interface Props {
  selectedResponse: WatchlistModel[];
  watchlistResponse: WatchlistListsModel[];
  type: WatchlistType | undefined;
  preferredCustomListSource?: CustomListSourceDisplay;
}

class State {
  showName: boolean = false;
  showIdentification: boolean = false;
  showCitizenship: boolean = false;
  showDateOfBirth: boolean = false;
  showDateOfRegistration: boolean = false;
  showDateOfDeath: boolean = false;
  showPlaceOfBirth: boolean = false;
  showAddresses: boolean = false;
  showPosition: boolean = false;
  showEducation: boolean = false;
  showSanction: boolean = false;
  showRelationship: boolean = false;
  selectedIdentification: WatchlistIdentificationModel | undefined;
  identificationModalVisible: boolean = false;
  selectedPosition: WatchlistPositionModel | undefined;
  positionModalVisible: boolean = false;
  selectedEducation: WatchlistEducationModel | undefined;
  educationModalVisible: boolean = false;
  selectedSanction: WatchlistSanctionModel | undefined;
  sanctionModalVisible: boolean = false;
  selectedRelationship: WatchlistRelationshipModel | undefined;
  relationshipModalVisible: boolean = false;
  customListSources: Record<string, CustomListSourceDisplay> = {};
}

export default WatchlistResultComponent;
